import type { Target } from "@/utils/types/flavor";

export const SAMPLE_TARGET: Target = {
  id: "tgt-strawberry-cream",
  name: "Gariguette Strawberry Cream",
  family: "fruity",
  descriptor:
    "Bright jammy strawberry over soft dairy cream, green-leaf lift, caramelized sugar finish.",
  taste: [7.2, 4.1, 0.4, 1.1, 0.6, 0.8, 0.5, 0.3, 0.1],
  smell: [
    8.6, 2.4, 8.9, 3.1, 2.1, 4.2, 3.8, 0.7, 0.4, 1.1, 0.2, 0.5, 6.8, 5.2, 7.4,
    3.6, 4.9, 0.8, 2.4, 1.7,
  ],
  // GC-MS headspace scan of the source food. Sums to 100% across detected
  // aromatics, sorted by ratio in the aside (not here, so authoring stays
  // close to the prototype's listing).
  source: "GC-MS headspace · n=3 ripe Gariguette berries · 12% cream",
  composition: [
    { compound: "Furaneol (DMHF)", ratio: 18.4, family: "sweet" },
    { compound: "Ethyl butyrate", ratio: 14.7, family: "fruity" },
    { compound: "Methyl butyrate", ratio: 9.8, family: "fruity" },
    { compound: "γ-Decalactone", ratio: 8.6, family: "dairy" },
    { compound: "Mesifurane", ratio: 7.2, family: "sweet" },
    { compound: "cis-3-Hexenol", ratio: 6.1, family: "green" },
    { compound: "Linalool", ratio: 5.4, family: "floral" },
    { compound: "δ-Decalactone", ratio: 4.9, family: "dairy" },
    { compound: "Hexanal", ratio: 4.2, family: "green" },
    { compound: "Ethyl hexanoate", ratio: 3.6, family: "fruity" },
    { compound: "(E)-2-Hexenal", ratio: 3.1, family: "green" },
    { compound: "Methyl cinnamate", ratio: 2.7, family: "floral" },
    { compound: "Vanillin", ratio: 2.3, family: "sweet" },
    { compound: "Acetaldehyde", ratio: 1.9, family: "fruity" },
    { compound: "α-Ionone", ratio: 1.4, family: "floral" },
    { compound: "Butyric acid", ratio: 1.1, family: "dairy" },
    { compound: "Benzaldehyde", ratio: 0.9, family: "sweet" },
    { compound: "β-Damascenone", ratio: 0.8, family: "floral" },
    { compound: "Maltol", ratio: 0.7, family: "sweet" },
    { compound: "Ethyl maltol", ratio: 0.6, family: "sweet" },
    { compound: "2-Methylbutanoic acid", ratio: 0.5, family: "roast" },
    { compound: "β-Ionone", ratio: 0.4, family: "floral" },
    { compound: "Hexyl acetate", ratio: 0.3, family: "fruity" },
    { compound: "Nerolidol", ratio: 0.2, family: "floral" },
    { compound: "2,5-Dimethylpyrazine", ratio: 0.2, family: "roast" },
  ],
};
